/**
 * 公共js工具类
 */
// import img from '@/assets/images/aside/nav_icon12'
export default {
    versionNumber: '1.0.0', // 当前版本号
    /**
     * 
     * @param {*} date 传入字符串，时间格式，时间戳格式
     * @param {*} format "yyyy-MM-dd hh:mm:ss"，"yyyy年MM月dd日 hh:mm:ss"，"yyyy年MM月dd日 hh时mm分ss秒"
     * @returns 
     */
    formatDateTime(date, format) {
        if (!date) return "";
        if (!(date instanceof Date)) {
            // 尝试将字符串或时间戳转为Date类型实例
            date = new Date(date);
        }
        let year = date.getFullYear();
        let month = date.getMonth() + 1;
        let day = date.getDate();
        let hour = date.getHours();
        let minute = date.getMinutes();
        let second = date.getSeconds();
        // 将时间元素转为两位数格式
        month = month < 10 ? "0" + month : month;
        day = day < 10 ? "0" + day : day;
        hour = hour < 10 ? "0" + hour : hour;
        minute = minute < 10 ? "0" + minute : minute;
        second = second < 10 ? "0" + second : second;

        format = format || "yyyy-MM-dd hh:mm:ss";
        format = format.replace("yyyy", year);
        format = format.replace("MM", month);
        format = format.replace("dd", day);
        format = format.replace("hh", hour);
        format = format.replace("mm", minute);
        format = format.replace("ss", second);

        return format;
    },
    // 字典查询
    findLabelByValue(val, arr = []) {
        // 确保传入的arr是一个数组
        if (!Array.isArray(arr)) {
            throw new Error('arr must be an array.');
        }
        // 将val转换为字符串形式进行比较，确保数字和字符串内容相等时能正确匹配
        const stringVal = String(val);
        // 使用更现代的JavaScript特性来简化查找逻辑
        const item = arr.find(item => String(item.value) === stringVal);
        // 返回找到的label，如果没找到，则返回空字符串
        return item ? item.label : '';
    },
    /**
     * 去输入框前后空格
     */
    trim(str) {
        return str.replace(/(^\s*)|(\s*$)/g, "");
    },
}


// WEBPACK FOOTER //
// ./src/utils/utils.js